import { render, staticRenderFns } from "./BalancePage.vue?vue&type=template&id=ce13c386&scoped=true&"
import script from "./BalancePage.vue?vue&type=script&lang=js&"
export * from "./BalancePage.vue?vue&type=script&lang=js&"
import style0 from "./BalancePage.vue?vue&type=style&index=0&id=ce13c386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce13c386",
  null
  
)

export default component.exports